import React from "react";

export const StatusBadges = ({ statusName, isGlobal }) => {
  // Custom color maps
  const yellowStatuses = [
    "Request Accepted",
    "Intro Email Sent",
    "Intro Meeting Complete",
    "Planning Meeting Complete",
    "Auditor Assigned",
    "Assessment Scheduled",
    "Assessment in Progress",
    "Assessment Complete",
    "Draft Review by Client",
    "Pending",
    "Draft Report Delivered",
    "Sponsor Draft Report Available",
    "Report Anonymized"
  ];
  const group1ColorMap = {
    "Sent": { bg: "bg-blue-100", border: "border border-blue-400", text: "text-blue-700" },
    "Not Sent": { bg: "bg-gray-100", border: "border border-gray-400", text: "text-gray-700" },
    "In Progress": { bg: "bg-yellow-100", border: "border border-yellow-500", text: "text-yellow-800" },
    "In Review": { bg: "bg-purple-100", border: "border border-purple-500", text: "text-purple-700" },
    "In Remediation (Purchaser)": { bg: "bg-red-100", border: "border border-red-500", text: "text-red-700" },
    "In Remediation (Vendor)": { bg: "bg-orange-100", border: "border border-orange-400", text: "text-orange-800" },
    "Complete": { bg: "bg-green-100", border: "border border-green-500", text: "text-green-700" },
    "Archived": { bg: "bg-slate-100", border: "border border-slate-400", text: "text-slate-700" },
  };

  let badgeClass = "inline-flex items-center rounded-md px-2 py-1 text-xs font-medium min-w-max";
  let colorClass = "";

  if (isGlobal) {
    colorClass = "bg-purple-100 text-purple-700 border border-purple-400";
  } else if (!isGlobal && isGlobal !== undefined) {
    colorClass = "bg-gray-100 text-gray-700 border border-gray-400";
  } else if (group1ColorMap[statusName]) {
    const color = group1ColorMap[statusName];
    colorClass = `${color.bg} ${color.text} ${color.border}`;
  } else if (yellowStatuses.includes(statusName)) {
    colorClass = "bg-yellow-100 text-yellow-800 border border-yellow-500";
  } else {
    switch (statusName) {
      case "Released":
        colorClass = "bg-green-100 text-green-700 border border-green-500";
        break;
      case "Pending":
      case "In Review":
      case "In Progress":
        colorClass = "bg-yellow-100 text-yellow-800 border border-yellow-500";
        break;
      case "Rejected":
      case "Cancelled":
        colorClass = "bg-red-100 text-red-700 border border-red-500";
        break;
      case "Not Sent":
        colorClass = "bg-gray-100 text-gray-700 border border-gray-400";
        break;
      case "Published":
        colorClass = "bg-purple-100 text-purple-700 border border-purple-400";
        break;
      case "Upcoming":
      case "Sent":
        colorClass = "bg-blue-100 text-blue-700 border border-blue-400";
        break;
      case "Archived":
        colorClass = "bg-slate-100 text-slate-700 border border-slate-400";
        break;
      default:
        colorClass = "bg-green-100 text-green-700 border border-green-500";
        break;
    }
  }

  return (
    <div>
      <span className={`${badgeClass} ${colorClass}`}>{statusName}</span>
    </div>
  );
};
